import LoadingSVG from "@design-system/ui-icons/vanilla/Loading"
import { createIcon } from "../createIcon"

export const LoadingIcon = createIcon(LoadingSVG)
